import { Box } from "@mui/material";
import DetailDataGrid from "../../../components/AppDataGrid/DetailDataGrid";
import { format } from "date-fns";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMessage } from "../../../../base/MessageProvider";
import {
  deleteAuditions,
  getDraftAuditionList,
} from "../../../actions/auditions";
import { StorageConstants } from "../../../storage/storageConstants";
import useDebounce from "../../../../base/useDebounce";
import { getGridStringOperators } from "@mui/x-data-grid";
import {
  deepCopy,
  hideLoadingOverlay,
  showLoadingOverlay,
} from "../../../../utils";

const DraftAuditions = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    refreshData() {
      fetchData();
    },
    delete() {
      onPressDeleteAll();
    },
  }));

  const { visible } = props;

  const storedPage = localStorage.getItem(StorageConstants.DRAFT_AUDITION_PAGE);
  const storedPageSize = localStorage.getItem(
    StorageConstants.DRAFT_AUDITION_PER_PAGE
  );

  const dispatch = useDispatch();
  const alert = useMessage();

  const selectedAuditionTab =
    useSelector((state) => state.auditionReducer.selectedAuditionTab) ?? 0;
  const loading = useSelector((state) => state.auditionReducer?.loading);
  const selectedLocation =
    useSelector((state) => state.auditionReducer.selectedLocation) ?? "ALL";
  const draftAuditionsList =
    useSelector((state) => state.auditionReducer?.draftAuditionsList) ?? [];
  const draftAuditionsListMetaData = useSelector(
    (state) => state.auditionReducer?.draftAuditionsListMetaData
  );

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 800);

  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowsState, setRowsState] = useState({
    page: storedPage ? +storedPage : 0,
    pageSize: storedPageSize ? +storedPageSize : 10,
  });

  const onSelectionModelChange = (model, details) => setSelectedRows(model);

  const columns = [
    {
      field: "jobCode",
      headerName: "Audition",
      width: 140,
      filterOperators: getGridStringOperators().filter(
        (a) => a.value === "contains"
      ),
    },
    {
      flex: 1,
      field: "addedAt",
      headerName: "Date",
      minWidth: 172,
      filterable: false,
      valueGetter: (params) =>
        `${format(new Date(params.value), "EEEE")} at ${format(
          new Date(params.value),
          "h:mm aaa"
        )}`,
    },
    {
      flex: 1,
      field: "userName",
      headerName: "Name",
      valueGetter: (params) => params.value || "-",
      minWidth: 198,
      filterable: false,
    },
    {
      flex: 1,
      field: "projectName",
      headerName: "Project",
      valueGetter: (params) => params.value || "-",
      minWidth: 116,
      filterable: false,
    },
    {
      // flex: 1,
      field: "minAge",
      headerName: "Age",
      valueGetter: (params) => `${params.value}-${params.row?.maxAge}`,
      width: 105,
      filterable: false,
    },
    // {
    //     // flex: 1,
    //     field: 'isOnline',
    //     headerName: 'Status',
    //     valueGetter: (params) =>
    //         params.value ? 'Online' : 'Offline',
    //     renderCell: (params) =>
    //         <div className={clsx("flex gap-2 items-center font-['Poppins-Light'] py-[5px] px-2 rounded-full", {
    //             "text-[#2AA000] bg-[#9DFFB8]": params.row?.isOnline,
    //             "text-[#6D7175] bg-[#E4E5E7]": !params.row?.isOnline
    //         })}>
    //             {params.row?.isOnline ? <div className="w-[10px] h-[10px] rounded-full bg-[#2AA000]" /> : <div className="w-[10px] h-[10px] rounded-full bg-[#5C5F62]" />}
    //             <h2 className="mt-[2px] text-[10px]">{params.value}</h2>
    //         </div>,
    //     width: 110,
    // },
    // {
    //     // flex: 1,
    //     field: 'selfTest',
    //     headerName: 'Self Test Invitation',
    //     valueGetter: (params) =>
    //         params.value ? 'Done' : 'Pending',
    //     renderCell: (params) =>
    //         <div className={clsx("flex gap-1 items-center font-['Poppins-Light'] py-[5px] px-2 rounded-full min-w-[64px]", {
    //             "text-[#8A6116] bg-[#FFEA8A]": params.row?.selfTest,
    //             "text-[#6D7175] bg-[#E4E5E7]": !params.row?.selfTest
    //         })}>
    //             {params.row?.selfTest ? <div className="w-[10px] h-[10px] rounded-full border-[1px] border-[#8A6116]" /> : <div className="w-[10px] h-[10px] rounded-full border-[1px] border-[#5C5F62]" />}
    //             <h2 className="mt-[2px] text-[10px]">{params.value}</h2>
    //         </div>,
    //     width: 150,
    // },
    {
      flex: 1,
      field: "profileCategoryName",
      headerName: "Tags",
      valueGetter: (params) =>
        params.value ? `${params.value}, ${params.row?.roleTypeName}` : "-",
      // minWidth: 119,
      minWidth: 200,
      filterOperators: getGridStringOperators().filter(
        (a) => a.value === "contains"
      ),
    },
    {
      flex: 1,
      field: "auditionLocation",
      headerName: "Location",
      valueGetter: (params) => params.value || "-",
      minWidth: 188,
    },
    // {
    //     flex: 1,
    //     field: 'castingDirector',
    //     headerName: 'Casting Director',
    //     minWidth: 188,
    // },
    // {
    //     flex: 1,
    //     field: 'productionHouse',
    //     headerName: 'Proudction house',
    //     minWidth: 188,
    // }
  ];

  const onPaginationModelChange = (model) => {
    setRowsState(model);
    localStorage.setItem(
      StorageConstants.DRAFT_AUDITION_PAGE,
      JSON.stringify(model.page)
    );
    localStorage.setItem(
      StorageConstants.DRAFT_AUDITION_PER_PAGE,
      JSON.stringify(model.pageSize)
    );
  };

  const onFilterModelChange = (model) => {
    const filterModel = deepCopy(model);
    console.log(filterModel.items);

    if (filterModel.items.length && !filterModel.items[0].value) {
      setSearchTerm("");
      return;
    }
    setSearchTerm(filterModel.items[0]?.value);
  };

  const handleDelete = async () => {
    showLoadingOverlay();
    dispatch(
      deleteAuditions(
        { includesJobId: selectedRows?.join(",") },
        (res) => {
          fetchData();
          setSelectedRows([]);
          alert.showSuccess(res?.message ?? "Successfully deleted");
        },
        (error) => {
          alert.showError(error?.message ?? "Something went wrong");
        }
      )
    );
    hideLoadingOverlay();
  };

  const onPressDeleteAll = () => {
    if (!selectedRows?.length) {
      alert.showError("Please select atleast one row!!");
      return;
    }
    alert.showConfirmation({
      message: "Are you sure you want to delete?",
      button1Title: "Cancel",
      button2Title: "Delete",
      onPressBtn1: () => {},
      onPressBtn2: handleDelete,
    });
  };

  useEffect(() => {
    if (draftAuditionsList) {
      setRows(
        draftAuditionsList.map((item) => ({
          ...item,
          id: item.jobId,
          userName: item?.user
            ? `${item?.user.firstName} ${item?.user?.lastName ?? ""}`
            : null,
          projectName: item?.project?.name,
          profileCategoryName: item?.profileCategory?.name,
          roleTypeName: item?.roleType?.name,
        }))
      );
    }
  }, [draftAuditionsList]);

  const fetchData = async () => {
    dispatch(
      getDraftAuditionList({
        page: +rowsState.page + 1,
        perPage: rowsState.pageSize,
        searchedKeyword:
          debouncedSearchTerm === "" ? undefined : debouncedSearchTerm?.trim(),
        location: selectedLocation === "ALL" ? undefined : selectedLocation,
      })
    );
  };

  useEffect(() => {
    if (visible) {
      if (debouncedSearchTerm) {
        fetchData();
      } else {
        setRowsState({
          page: storedPage ? +storedPage : 0,
          pageSize: storedPageSize ? +storedPageSize : 10,
        });
        fetchData();
      }
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (visible) {
      fetchData();
    }
  }, [visible, rowsState, selectedLocation]);

  if (!visible) return <></>;

  return (
    <Box>
      <DetailDataGrid
        rows={rows}
        columns={columns}
        paginationModel={rowsState}
        searchTerm={searchTerm}
        onSearchTermChange={setSearchTerm}
        onPaginationModelChange={onPaginationModelChange}
        onFilterModelChange={onFilterModelChange}
        rowCount={+draftAuditionsListMetaData?.total_pagination_job_count || 0}
        loading={loading}
        onPressDelete={onPressDeleteAll}
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={onSelectionModelChange}
      />
    </Box>
  );
});

export default DraftAuditions;
